export default __webpack_public_path__ + "static/media/lewc_seal.28f97079.png";